import { withAuthenticator } from "@aws-amplify/ui-react";
import awsconfig from "../aws-exports";
import ContactForm from "./contactForm";

const Contact = ({ signOut }) => {
  return (
    <>
      <ContactForm />
      <button onClick={signOut}>Sign out</button>
    </>
  );
};

export default withAuthenticator(Contact);
